import { DateTime } from "luxon";
import i18n from "./lib/i18n";

/**
 * Formats a date into a string.
 * @param date - The date to format.
 * @returns The formatted date.
 */
const formatDate = (date: string | DateTime): string => {
	if (!date) {
		return "";
	}
	const dateTime = typeof date === "string" ? DateTime.fromISO(date) : date;
	return dateTime.toFormat("MMMM dd, yyyy");
};

const formatDateToLocalizedString = (date: string) =>
	DateTime.fromFormat(date, "MMMM d, yyyy", { locale: "en-US" })
		.setLocale(i18n.language)
		.toLocaleString(DateTime.DATE_FULL);

const getCurrentDate = () => {
	return DateTime.now().setLocale(i18n.language).toFormat("MMMM dd, yyyy");
};

const normalizeDateString = (input: string) =>
	input.replace(" ", "T").replace(/\+00$/, "Z");

const formatTimeString = (time: string, timeStamp?: boolean, useUTC = true) => {
	const normalizedTime = normalizeDateString(time);
	const date = new Date(normalizedTime);
	const options: Intl.DateTimeFormatOptions = {
		year: "numeric",
		month: "long",
		day: "numeric",
		...(timeStamp
			? {
					hour: "numeric",
					minute: "numeric",
					...(useUTC ? { timeZone: "UTC" } : {}),
					hour12: true,
				}
			: {}),
	};

	const formattedDate = date.toLocaleString("en-US", options);
	return formattedDate;
};

const formatExamDate = (examDate: string): string => {
	const dateTime = DateTime.fromISO(examDate);
	return dateTime.isValid ? dateTime.toFormat("MMMM dd, yyyy") : examDate;
};

export {
	formatDate,
	formatTimeString,
	formatExamDate,
	formatDateToLocalizedString,
	getCurrentDate,
};
